module.exports = __webpack_public_path__ + "static/media/h5_drawing_pic.dd9a5b77.png";